import axios from 'axios';
import { getAuth } from "firebase/auth";
import AmplitudeEvent from '../components/Amplitude/AmplitudeEvent'
import firebaseErrors from "../firebaseErrors.json";
import 'firebase/auth';
import { Timestamp, arrayRemove } from "firebase/firestore";
import { db } from "../firebase";
import { collection, getDocs, doc, getDoc, updateDoc, arrayUnion, setDoc, serverTimestamp, query, orderBy, startAt, endAt, where } from "firebase/firestore";

const baseURL = "https://www.roundpier.com/api";

const CLUB_PROJECTS = 'club-projects'
const CLUBS = 'clubs'
const MEMBERSHIPS = "memberships"
const ENROLLMENTS = "enrollments"
const UPDATES = "updates"
const SUBMISSIONS = "submissions"

export const fetchClubProjects = async (clubId) => {
  try {
    const clubSnapshot = await getDocs(collection(db, CLUB_PROJECTS));
    const clubProjectList = clubSnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(doc => doc.club === clubId); // Filter by clubId

    return clubProjectList
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  } finally {
    console.log(true);
  }
};

export const fetchProjectsByCategory = async (category) => {
  try {
    const q = query(collection(db, CLUB_PROJECTS), where("category", "==", category));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const projectList = querySnapshot?.docs?.map(doc => ({ id: doc.id, ...doc.data() }))
      return projectList
    } else {
      console.error("No document found for the provided category.");
      return null;
    }
  } catch (error) {
    console.error("Error fetching project by category", error);
  }
};

export const fetchClubProjectById = async (projectId) => {
  try {
    const docRef = doc(db, CLUB_PROJECTS, projectId);
    const docSnapshot = await getDoc(docRef);
    if (docSnapshot.exists()) {
      return { id: docSnapshot.id, ...docSnapshot.data() };
    } else {
      console.error("No document found for the provided projectId.");
      return null;
    }
  } catch (error) {
    console.error("Error fetching project by id", error);
  }
};

export const fetchClubsOnlyExplore = async () => {
  try {
    const q = query(collection(db, CLUBS), where("explore", "==", true));
    const clubSnapshot = await getDocs(q);

    const clubList = clubSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return clubList
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  }
};

export const fetchClubs = async () => {
  try {
    const clubSnapshot = await getDocs(collection(db, CLUBS));

    const clubList = clubSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return clubList
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  }
};

export const fetchClubById = async (clubId) => {
  try {
    const clubDoc = doc(db, CLUBS, clubId);
    const clubSnapshot = await getDoc(clubDoc);
    if (clubSnapshot.exists()) {
      return clubSnapshot.data()
    }
    else {
      console.error("No such document!");
      return null
    }
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  }
};

export const fetchMemberships = async (currentUserId) => {
  try {
    const membershipsSnapshot = await getDocs(query(collection(db, MEMBERSHIPS), where("user", "==", currentUserId)));
    return membershipsSnapshot.docs.map(doc => doc.data());
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  }
};

export const fetchEnrollments = async () => {
  try {
    const enrollmentsSnapshot = await getDocs(collection(db, ENROLLMENTS));
    const enrollments = enrollmentsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return enrollments
  } catch (error) {
    console.error("Error fetching enrollments", error);
  }
};

export const fetchAllProjects = async () => {
  try {
    const clubSnapshot = await getDocs(collection(db, CLUB_PROJECTS));
    const clubProjectList = clubSnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))

    return clubProjectList
  } catch (error) {
    console.error("Error fetching clubs or memberships:", error);
  } finally {
    console.log(true);
  }
};

export const fetchUpdatesByClub = async (clubId) => {
  console.log("fetchUpdatesByClub", clubId)
  try {
    const docRef = doc(db, UPDATES, clubId);
    const docSnapshot = await getDoc(docRef);
    if (docSnapshot.exists()) {
      return { id: docSnapshot.id, ...docSnapshot.data() };
    } else {
      console.error("No document found for the provided clubId.");
      return null;
    }
  } catch (error) {
    console.error("Error fetching updates by clubId:", error);
  }
};

export const checkMembership = async (currentUser, clubId) => {
  if (currentUser) {
    const membershipsCollection = collection(db, "memberships");
    const membershipsQuery = query(membershipsCollection, where("user", "==", currentUser.uid), where("clubId", "==", clubId));
    const membershipsSnapshot = await getDocs(membershipsQuery);
    return membershipsSnapshot
  }
};

export const fetchSubmissionByUser = async (clubId, projectId, team, user) => {
  try {
    const submissionId = `${clubId}_${projectId}_${team}_${user}`
    const clubDoc = doc(db, SUBMISSIONS, submissionId);
    const clubSnapshot = await getDoc(clubDoc);
    if (clubSnapshot.exists()) {
      return clubSnapshot.data()
    }
    else {
      console.error("No such submission document!");
      return null
    }
  } catch (error) {
    console.error("Error fetching submission", error);
  }
};

// Fetch all users from 'users' collection
export const getAllUsers = async () => {
  const snapshot = await getDocs(collection(db, 'users'));
  return snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id,
  }));
};


export async function getAllMembersOfClub(clubId) {
  const membershipRef = collection(db, "memberships");

  const prefix = `${clubId}_`;
  const q = query(
    membershipRef,
    orderBy("__name__"),
    startAt(prefix),
    endAt(prefix + '\uf8ff')  // Firestore range query trick
  );

  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id,
  }));
}

export async function checkIfUserIsAdminForClub(clubId, userId) {
  const membershipRef = doc(db, "memberships", `${clubId}_${userId}`);
  const membershipDoc = await getDoc(membershipRef);

  const flag = membershipDoc.data()?.role === "admin"
  console.log("flag", flag)
  if (flag === true) {
    return true
  }
  else {
    return false 
  }
}
export async function getNameFromId(id) {
  const userRef = doc(db, "users", id);
  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    return userDoc.data().name;
  } else {
    console.error("No such user document!");
    return null;
  }
}

export async function addUserToClub(clubId, userId, role) {
  try {
    const membershipId = `${clubId}_${userId}`;
    const membershipRef = doc(db, "memberships", membershipId);
    const name = await getNameFromId(userId);

    await setDoc(membershipRef, {
      clubId: clubId,
      user: userId,
      dateJoined: serverTimestamp(),
      role: role,
      name: name
      
    });
    return { success: true, message: "User successfully added to club." };
  } catch (error) {
    console.error("Error adding user to club:", error);
    throw error;
  }
}

export async function addUserAsAdmin(clubId, userId) {
  const membershipRef = doc(db, "memberships", `${clubId}_${userId}`);
  await updateDoc(membershipRef, { role: "admin" });
}


export function getUserByUid(uid) {
  const user = getDoc(doc(db, "users", uid));
  return user;
}

export function getCurrentUser() {
  const currentUser = getAuth().currentUser;
  return currentUser;
}

export function getToken() {
  const currentUser = getAuth().currentUser;
  return currentUser ? currentUser.getIdToken() : null;
}

export function getUserId() {
  const userId = getAuth()?.currentUser?.uid;
  return userId;
}

export function get(endpoint) {
  return axios.get(baseURL + endpoint)
    .then(response => response.data)
    .catch(error => console.error(error));
}

export function post(endpoint, reqData) {
  return axios.post(baseURL + endpoint, reqData)
    .then(response => response.data)
    .catch(error => console.error(error));
}

export function Amplitude() {
  return AmplitudeEvent();
}

export function getErrorMessage(error) {
  const code = error.code;
  const message = firebaseErrors[code] || "An unknown error occurred.";
  return message;
}

export const formatTimestamptoDate = (date) => {
  if (!date) return null
  else {
    const newDate = date instanceof Timestamp ? date.toDate() : date
    return new Date(newDate).toLocaleDateString("en-GB")
  }
}

export const formatTimestamptoDateTime = (date) => {
  if (!date) return null
  else {
    const newDate = date instanceof Timestamp ? date.toDate() : date
    return new Date(newDate).toLocaleString("en-GB", { year: "numeric", month: "numeric", day: "numeric", hour: '2-digit', minute: '2-digit' })
  }
}


export async function getUserMembershipStatus(userId, clubId) {
  const membershipsQuery = query(
    collection(db, "memberships"),
    where("user", "==", userId),
    where("clubId", "==", clubId)
  );
  const snapshot = await getDocs(membershipsQuery);
  return !snapshot.empty;
}

export async function getTeamMembersData(memberIds) {
  const usersQuery = query(collection(db, "users"), where("uid", "in", memberIds));
  const teamMembers = await getDocs(usersQuery);
  return teamMembers.docs.map(doc => ({
    name: doc.data().name,
    role: doc.data().role,
    uid: doc.data().uid
  }));
}

export async function updateTeamInFirestore(clubId, projectId, teamData, userId) {
  const docName = `${clubId}_${projectId}`;
  const docRef = doc(db, "enrollments", docName);
  const updatedTeam = { ...teamData, members: [...(teamData.members ?? [])] };

  try {
    await setDoc(
      docRef,
      {
        clubId,
        projectId,
        date: serverTimestamp(),
        teams: arrayUnion(updatedTeam)
      },
      { merge: true }
    );
  } catch (error) {
    console.error("Error adding new team:", error);
  }
}



export async function deleteTeamFromFirestore(clubId, projectId, teamName, teamMembers) {
  const docName = `${clubId}_${projectId}`;
  const docRef = doc(db, "enrollments", docName);

  try {
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.error("Document does not exist.");
      return;
    }

    const data = docSnap.data();
    const teams = data.teams || [];

    // Find the exact team object to remove
    const teamToRemove = teams.find(team =>
      team.name === teamName 
    );

    if (!teamToRemove) {
      console.warn("Team not found or members don't match exactly.");
      return;
    }

    // Remove the team
    await updateDoc(docRef, {
      teams: arrayRemove(teamToRemove)
    });

    console.log("Team successfully removed.");
  } catch (error) {
    console.error("Error removing team:", error);
  }
}

export const updateProfile = async (uid, updates) => {
  const userRef = doc(db, "users", uid);
  await updateDoc(userRef, updates);
};

export const getUserData = async (uid) => {
  try {
    const userRef = doc(db, "users", uid); // reference to specific user
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      const userData = userSnap.data();

      // Save to localStorage (convert object to string first)
      localStorage.setItem("userData", JSON.stringify(userData));

      return userData;
    } else {
      console.log("No such user!");
      return null;
    }
  } catch (error) {
    console.error("Error getting user data:", error);
    throw error;
  }
};
